// HEIGHT ADAPT +++++++++++++++++++++++++
window.onload = function () {

   // 表示限界期限
   const limitDate = new Date(2025, 7, 16);
   // 現在の日付
   const currentDate = new Date();
   // new-iconのdom
   let newIconContent = document.getElementById("js-limit-new");
   // 3ヶ月が経過していない場合は表示
   if (currentDate < limitDate) {
      newIconContent.style.display = "block";
   }

   let newIconContent2 = document.getElementById("js-limit-new2");
   // 3ヶ月が経過していない場合は表示
   if (currentDate < limitDate) {
      newIconContent2.style.display = "block";
   }

   $.fn.matchHeight._afterUpdate = function (load, resize) {

      $(".box1").matchHeight({
         byRow: false,
      });
      $(".box2").matchHeight({
         byRow: false,
      });
      $(".box3").matchHeight({
         byRow: false,
      });
      $(".box4").matchHeight({
         byRow: false,
      });
      $(".box5").matchHeight({
         byRow: false,
      });
      $(".box6").matchHeight({
         byRow: false,
      });
      $(".box7").matchHeight({
         byRow: false,
      });
      $(".box8").matchHeight({
         byRow: false,
      });
      $(".box9").matchHeight({
         byRow: false,
      });
      $(".box10").matchHeight({
         byRow: false,
      });
      $(".box11").matchHeight({
         byRow: false,
      });



      $(".slide a").matchHeight();
      $(".slide .function-mark").matchHeight();
   }


   $(".coolshot-slider").slick({
      slidesToShow: 2,
      slidesToScroll: 1,
      swipe: false,
      arrows: true,
      fade: false,
      dots: true,
      speed: 600,
      autoplay: true,
      autoplaySpeed: 5000,
      touchThreshold: 5,
      focusOnSelect: true,
      cssEase: 'ease',
      waitForAnimate: true,
      edgeFriction: 0,
      responsive: [
         {
            breakpoint: 1024,
            settings: {
            }
         },
         {
            breakpoint: 768,
            settings: {
               slidesToShow: 1,
               slidesToScroll: 1,
               swipe: true,
            }
         }
      ]

   });

}

